module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/ico-controller.2b0ee395.png";